import { Upload } from "lucide-react";
import { resolveMediaUrl } from "../../../lib/api";

export const SeoHeroImageUpload = ({ heroImage, uploading, onUpload }) => (
  <div className="space-y-3">
    <h4 className="font-semibold text-sm">Fotografía principal</h4>
    <div className="flex items-center gap-3">
      {heroImage && (
        <img src={resolveMediaUrl(heroImage)} alt="" className="h-16 w-28 object-cover rounded" data-testid="seo-hero-image-preview" />
      )}
      <label data-testid="seo-hero-image-upload-label" className="flex items-center gap-2 border rounded px-3 py-2 text-xs cursor-pointer hover:bg-secondary/50">
        <Upload size={14} /> {uploading ? "Subiendo..." : "Subir fotografía"}
        <input data-testid="seo-hero-image-upload-input" type="file" accept="image/*" className="hidden" onChange={onUpload} disabled={uploading} />
      </label>
    </div>
  </div>
);
